import { Component } from '@angular/core';
import { EViewType } from 'projects/shared/lib/enum/view-type/view-type.enum';
import { ProductListItemMHComponent } from '../base/product-list-item.component';
import { EPriceMark } from 'projects/shared/lib/services/INTEGRA_Shop_Client';

@Component({
  selector: 'app-product-list-item-grid',
  templateUrl: './product-list-item-grid.component.html',
  standalone: false
})
export class ProductListItemGridMHComponent extends ProductListItemMHComponent {

  public ePriceMark: typeof EPriceMark = EPriceMark;

  constructor() {
    super();
    this.viewType = EViewType.GRID;
  }

}
